import { StateCreator } from "zustand";

import { RootStore } from ".";

export interface CustomSearchActions {
	openCustomSearchTool: () => void;
}

export type CustomSearchStore = CustomSearchActions;

export const createCustomSearchSlice: StateCreator<
	RootStore,
	[],
	[],
	CustomSearchStore
> = (set) => ({
	openCustomSearchTool: () => set({ currentMapToolView: "custom-search" }),
});
